// Tag detail page (CHG-1266 / ITER-3391).
//
// FORWARD-PROMISED backend per CHG-1237. Detail page renders against
// the entity-hint contract; status cards + tabs gracefully render '—'
// or empty state when the forward-promised backend returns 404.
//
// Spec: specs/tier-05-experience/tag-detail-v2.cross-screen.yaml.

import { DetailPage } from "../components/composition";
import { tagDetailConfig } from "../generated/screens/tag-detail";

export function TagDetail() {
  return <DetailPage config={tagDetailConfig} />;
}
